import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=6f8ab0b9&scoped=true&"
import script from "./fullScreen.vue?vue&type=script&lang=js&"
export * from "./fullScreen.vue?vue&type=script&lang=js&"
import style0 from "./fullScreen.vue?vue&type=style&index=0&id=6f8ab0b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ab0b9",
  null
  
)

export default component.exports